export default __webpack_public_path__ + "static/Email-39ddfb7d92a7e92d3c9d1b2d8f3ece51.svg";